export enum ResponseCode {
  SUCCESS = "ACC",
  ERROR = "ERR",
  REJECTED = "REJ",
  GENERAL_ERROR = "ERROR",
}
